import { PaymentType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { PAYMENT_TYPES } from "../../utils/constants";

export const createPaymentType = async (data: PaymentType) => await post<PaymentType, string>(PAYMENT_TYPES, data);
export const updatePaymentType = async (data: PaymentType) => await put<PaymentType, string>(PAYMENT_TYPES, data);
export const getPaymentTypes = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    const url = `${PAYMENT_TYPES}?${queryParams.toString()}`;
    return await get<PagedResultsType<PaymentType>>(url)
};